import React from "react";


import {
    Col,
    Row
} from "react-bootstrap";


import {
    SectionContainerComponent
} from "@Components/Sections";

import {
    IconCardComponent
} from "@Components/Elements";


import iconMailL from "@Icons/SVG/icon-mail-l-white.svg";
import iconSearchL from "@Icons/SVG/icon-search-l-white.svg";
import iconDollarL from "@Icons/SVG/icon-dollar-l-white.svg";


import "./index.scss";


const HowItWorksSectionCardsData = [
    {
        cardId: 1,
        cardTitle: 'Connect your e-mail',
        cardIcon: iconMailL,
        cardDescription: 'Securely connect your email with read-only default access. C.A.R.E. sweeps past & future receipts, confirmations, and support threads.',
    },
    {
        cardId: 2,
        cardTitle: 'Qyvo finds claims',
        cardIcon: iconSearchL,
        cardDescription: 'You Relax. Qyvo\'s C.A.R.E. pinpoints refundable taxes & fees on flights plus hotels, car rentals, digital subscriptions, surprise add-ons and hidden fees automatically.',
    },
    {
        cardId: 3,
        cardTitle: 'Get paid',
        cardIcon: iconDollarL,
        cardDescription: 'Watch money hit your card or bank. We file and chase every claim. We charge 25% success fee —only after you\'re paid.',
    },
];


export const HomePageHowItWorksSection:React.FC = () => {


    const sectionTitle = `How Qyvo works?`;
    const sectionDescription = `3 simple steps to automatic refunds:`;

    const sectionClassName = 'home-page__how-it-works-section';


    const howItWorksCardsList = HowItWorksSectionCardsData.map((item) =>
        <IconCardComponent
            key={item.cardId}
            cardIcon={{ iconSrc: item.cardIcon, iconSize: 'xl', iconBackground: 'primary' }}
            cardTitle={item.cardTitle}
            cardDescription={`<span>${item.cardDescription}</span>`}
            cardOrientationType={'vertical'}
            xl={4}
        />
    );


    return (
        <SectionContainerComponent
            id={sectionClassName}
            sectionHeaderText={sectionTitle}
            sectionDescriptionText={sectionDescription}
            sectionType={'main'}
        >
            <Col xs={12} className={'home-page__how-it-works-section__cards-list'}>
                <Row className={'home-page__how-it-works-section__cards-list__content'}>
                    {howItWorksCardsList}
                </Row>
            </Col>
        </SectionContainerComponent>
    );

};


export default HomePageHowItWorksSection;
